import { __decorate, __metadata } from 'tslib';
import React, { PureComponent } from 'react';
import Divider from '@tencent/dui/lib/components/Divider';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import Menu from '@tencent/dui/lib/components/Menu';
import styles from './menu.less.js';
import { EnvContext } from '../../controllers/workbench/context.js';
import { MenuContent } from './menu-content.js';
import { evaluate } from '../../controllers/base/evaluate.js';
import { Inject } from '@tencent/ioc';
import { BadgeService } from '../../services/badge/badge-service.js';
import { PlatformUtil } from '../../utils/platform-utils.js';
import { MenuService } from '../../services/menu/menu-service.js';
import { withAutoPositionedTooltip } from '../tooltip/with-auto-positioned-tooltip.js';
import { WorkbenchSettingsService } from '../../services/settings/setting-service.js';

let firstNonDivider = Infinity;
class MainMenuDropdown extends PureComponent {
    constructor() {
        super(...arguments);
        this.levelInfo = { current: 0 };
        this.generateMenuTree = (item, index) => {
            if (index === 0) {
                this.enterMenuTree();
            }
            if (item.name === 'divider') {
                return React.createElement(Divider, { key: `${item.name}-${index}` });
            }
            const extraStyle = {};
            firstNonDivider = Infinity;
            if (evaluate(item.shouldHide, false)) {
                return null;
            }
            const subMenus = item.children
                .filter(child => !evaluate(child.shouldHide, false))
                .filter(this.removeUnnecessaryDivider);
            if (item.children.length === 0 || (subMenus.length === 0 && item.onClick)) {
                if ((item === null || item === void 0 ? void 0 : item.showType) === 'horizontal') {
                    // 如果是水平展示但没子菜单，不显示
                    return null;
                }
                const badge = this.checkBadge(item.name);
                return this.generateMenuItem({
                    item,
                    index,
                    badge,
                    extraStyle,
                });
            }
            if ((item === null || item === void 0 ? void 0 : item.showType) === 'horizontal') {
                // 如果subMenus的长度小于4 宽度为240px， 大于4 宽度为280px，长度大于5 宽度为360px
                let defaultWidth = 240;
                if (subMenus.length >= 5) {
                    defaultWidth = 360;
                }
                else if (subMenus.length >= 4) {
                    defaultWidth = 280;
                }
                const itemStyle = typeof item.style === 'function' ? item.style() : item.style;
                return React.createElement(Dropdown.Keep, null,
                    React.createElement("div", { className: styles['workbench-menu-horizontal'], style: Object.assign({ minWidth: defaultWidth }, itemStyle) }, subMenus.map((subItem, i) => {
                        var _a, _b;
                        const disabled = this.shouldDisabled(subItem);
                        return (React.createElement("div", { key: `${subItem.name}-item`, className: styles['workbench-menu-horizontal-item-box'], onClick: (e) => this.handleHorizontalMenuClick(e, subItem, disabled) },
                            (((_a = subItem.children) === null || _a === void 0 ? void 0 : _a.length) > 0) && (React.createElement(Dropdown, { key: `${subItem.name}-dropdown-${i}`, style: { width: '100%' }, disabled: disabled, trigger: "click", alignment: "left-outer", placement: "bottom", dropContentStyle: { minWidth: '200px' }, dropContent: React.createElement(Dropdown.Keep, null,
                                    React.createElement(Menu, { key: `${subItem.name}-menu-${i}`, selectable: false, onClick: (id, e) => this.handleMenuClick(id, e, true) }, subItem.children.map(this.generateMenuTree))), onVisibleChange: (visible) => {
                                    var _a;
                                    (_a = subItem.onVisibleChange) === null || _a === void 0 ? void 0 : _a.call(subItem, visible);
                                    this.handleVisibleChange(visible, subItem.name);
                                    if (visible) {
                                        subItem.children.forEach((child) => {
                                            var _a;
                                            (_a = child.onShow) === null || _a === void 0 ? void 0 : _a.call(child);
                                        });
                                    }
                                } },
                                React.createElement(Dropdown.Keep, null, this.generateMenuHorizontalItem(subItem, disabled)))),
                            !((_b = subItem.children) === null || _b === void 0 ? void 0 : _b.length) && React.createElement(Dropdown.Keep, { disabled: !disabled }, this.generateMenuHorizontalItem(subItem, disabled))));
                    })));
            }
            const menus = subMenus.map(this.generateMenuTree);
            const childLevelInfo = Object.assign({}, this.getCurrentLevelInfo());
            this.leaveMenuTree();
            if (item.children.length > 0 && subMenus.length === 0 && !item.onClick) {
                return null;
            }
            return this.genarateSubMenu(item, index, menus, childLevelInfo);
        };
        this.handleHorizontalMenuClick = (e, subItem, disabled) => {
            var _a;
            if (disabled) {
                return;
            }
            this.handleMenuClick(this.menuService.getPathByConfig(subItem).join('/'), e, !((_a = subItem.children) === null || _a === void 0 ? void 0 : _a.length));
        };
        this.handleMenuClick = (id, e, hideDropdown) => {
            if (hideDropdown) {
                // 因为 workbench-menu-horizontal 点击空白处不关闭下拉框，所以使用了Dropdown.Keep，点击子菜单项时，需要手动关闭下拉框
                this.props.shouldHideDropdown(true);
            }
            this.props.onMenuClick(id, e);
        };
        this.handleVisibleChange = (visible, name) => {
            if (visible && this.badgeTree.includes(name)) {
                // 移除红点（只有在设置当前item显示红点才能移除成功，倘若是因为子菜单设置红点而引起改item显示红点，此方法无法移除红点）
                this.badgeService.removeBadgeOn('menu', name);
            }
        };
        this.removeUnnecessaryDivider = (item, index, list) => {
            if (item.name === 'divider') {
                // 如果本条是分隔线，则进行判断
                if (index < firstNonDivider) {
                    // 如果是第一项，隐藏这条
                    return false;
                }
                const nextItem = list[index + 1];
                if (nextItem) {
                    if (nextItem.name === 'divider') {
                        // 如果下一项也是分隔线，则隐藏这条
                        return false;
                    }
                }
                else {
                    // 如果是最后一项，隐藏这条
                    return false;
                }
            }
            else if (firstNonDivider > index) {
                firstNonDivider = index;
            }
            return true;
        };
    }
    checkBadge(name) {
        return this.badgeTree.includes(name);
    }
    wrapWithPreventDismiss(item, menuItem, index) {
        return React.createElement(Dropdown.Keep, { key: `mainmenu-item-keep-${item.name}-${index}` }, menuItem);
    }
    shouldDisabled(item) {
        if (item.shouldDisabled) {
            return evaluate(item.shouldDisabled, false);
        }
        return false;
    }
    shouldCheck(item) {
        if (item.shouldCheck) {
            return evaluate(item.shouldCheck, false);
        }
        return false;
    }
    /**
     * 获取菜单项的说明（实际逻辑中，如果没有说明，则会返回 this.getShortcut() 返回的快捷键）
     *
     * @param item - 菜单配置项
     * @returns 菜单项说明，或者 undefined
     */
    getDescription(item) {
        return evaluate(item.description, null);
    }
    /**
     * 获取菜单项的快捷键（实际逻辑会以 this.getDescription() 返回的说明为先，如果没有说明则返回快捷键）
     *
     * @param item - 菜单配置项
     * @returns 菜单项说明，或者 undefined
     */
    getShortcut(item) {
        const { shortcut } = item;
        if (!shortcut) {
            return undefined;
        }
        // TODO: 将快捷键改为等宽字体
        return PlatformUtil.isMac() ? shortcut.mac : shortcut.win;
    }
    generateMenuItem({ item, index, badge, extraStyle, }) {
        var _a, _b;
        const needCheckPadding = item.shouldCheck !== undefined;
        const hasIcon = item.icon !== undefined;
        const checked = this.shouldCheck(item);
        this.recordLevelInfo(needCheckPadding, hasIcon, checked);
        const highlightStyle = item.preventHighlight ? { background: 'transparent' } : {};
        const itemStyle = typeof item.style === 'function' ? item.style() : item.style;
        const disabled = this.shouldDisabled(item);
        const key = `${item.name}-${index}`;
        let menuItem = React.createElement(Menu.Item, { id: this.menuService.getPathByConfig(item).join('/'), key: key, className: `mainmenu-item-${item.name} ${styles['workbench-menu-item']}`, disabled: disabled, style: Object.assign(Object.assign(Object.assign({}, extraStyle), itemStyle), highlightStyle), selected: this.shouldCheck(item), description: (_b = (_a = this.getDescription(item)) !== null && _a !== void 0 ? _a : this.getShortcut(item)) !== null && _b !== void 0 ? _b : '', icon: hasIcon
                ? React.createElement("div", { className: item.keepSvgIconColor ? styles['workbench-menu-item-icon-keep-color'] : styles['workbench-menu-item-icon'] }, evaluate(item.icon, null))
                : undefined, onMouseEnter: !disabled ? item.onMouseEnter : undefined, onMouseLeave: !disabled ? item.onMouseLeave : undefined },
            React.createElement(MenuContent, { item: item, badge: badge && !disabled }));
        if (item.tooltip) {
            menuItem = React.createElement(React.Fragment, { key: key }, withAutoPositionedTooltip(menuItem, item.tooltip, { style: { display: 'block' } }));
        }
        if (item.preventDismiss) {
            menuItem = this.wrapWithPreventDismiss(item, menuItem, index);
        }
        return menuItem;
    }
    enterMenuTree() {
        this.levelInfo.current += 1;
    }
    leaveMenuTree() {
        delete this.levelInfo[this.levelInfo.current];
        this.levelInfo.current -= 1;
    }
    recordLevelInfo(needCheckPadding, hasIcon, childBeenChecked) {
        const { current } = this.levelInfo;
        if (this.levelInfo[current]) {
            this.levelInfo[current].needCheckPadding = this.levelInfo[current].needCheckPadding || needCheckPadding;
            this.levelInfo[current].hasIcon = this.levelInfo[current].hasIcon || hasIcon;
            this.levelInfo[current].childBeenChecked = this.levelInfo[current].childBeenChecked || childBeenChecked;
        }
        else {
            this.levelInfo[current] = { needCheckPadding, hasIcon, childBeenChecked };
        }
    }
    generateMenuHorizontalItem(subItem, disabled) {
        var _a, _b;
        const badge = !disabled && this.checkBadge(subItem.name);
        const subItemStyle = typeof subItem.style === 'function' ? subItem.style() : subItem.style;
        const hasChildren = ((_a = subItem.children) === null || _a === void 0 ? void 0 : _a.length) > 0;
        // 统一子菜单 disabled 样式
        return React.createElement("div", { className: `${styles['workbench-menu-horizontal-item']} ${disabled ? styles['workbench-menu-horizontal-item-disabled'] : ''} ${hasChildren ? styles['has-children'] : ''}`, style: subItemStyle },
            (subItem.icon || subItem.iconClass) && React.createElement("div", { className: `${styles['workbench-menu-horizontal-item-icon']} ${(_b = subItem.iconClass) !== null && _b !== void 0 ? _b : ''}` }, subItem.icon),
            React.createElement("div", { className: styles['workbench-menu-horizontal-item-text'] },
                React.createElement(MenuContent, { item: subItem, badge: badge })));
    }
    getCurrentLevelInfo() {
        var _a;
        const { current } = this.levelInfo;
        return (_a = this.levelInfo[current]) !== null && _a !== void 0 ? _a : { hasIcon: false, needCheckPadding: false, childBeenChecked: false };
    }
    genarateSubMenu(item, index, menus, childLevelInfo) {
        const style = typeof item.style === 'function' ? item.style() : item.style;
        const popUpStyle = typeof item.popUpStyle === 'function' ? item.popUpStyle() : item.popUpStyle;
        const popupClassName = typeof item.popupClassName === 'function' ? item.popupClassName() : item.popupClassName;
        const disabled = this.shouldDisabled(item);
        const badge = !disabled && this.checkBadge(item.name);
        const hasIcon = item.icon !== undefined;
        const selfBeenChecked = this.shouldCheck(item);
        const needCheckPadding = childLevelInfo.needCheckPadding || !!item.syncCheckStatus;
        const { childBeenChecked } = childLevelInfo;
        const subMenuChecked = selfBeenChecked || (childBeenChecked && !!item.syncCheckStatus);
        this.recordLevelInfo(!!item.syncCheckStatus, hasIcon, subMenuChecked);
        let subMenu = React.createElement(Menu.SubMenu, { id: this.menuService.getPathByConfig(item).join('/'), className: `mainmenu-submenu-${item.name} ${styles['workbench-menu-item']}`, title: React.createElement(MenuContent, { item: item, badge: badge && !item.icon }), icon: item.icon
                ? React.createElement("div", { className: styles['workbench-menu-item-icon'] }, evaluate(item.icon, null))
                : undefined, key: `${item.name}-${index}`, selectable: needCheckPadding, selected: subMenuChecked, type: hasIcon ? 'with-icon' : 'normal', disabled: disabled, style: style, onVisibleChange: (visible) => {
                var _a;
                (_a = item.onVisibleChange) === null || _a === void 0 ? void 0 : _a.call(item, visible);
                this.handleVisibleChange(visible, item.name);
                if (visible) {
                    item.children.forEach((child) => {
                        var _a;
                        (_a = child.onShow) === null || _a === void 0 ? void 0 : _a.call(child);
                    });
                }
            }, popupStyle: popUpStyle, popupClassName: popupClassName }, menus);
        if (item.tooltip) {
            subMenu = React.createElement(React.Fragment, { key: `${item.name}-${index}` }, withAutoPositionedTooltip(subMenu, item.tooltip, { style: { display: 'block' } }));
        }
        return subMenu;
    }
    handleMouseDown(event) {
        var _a;
        if (((_a = this.settings.accessibility) === null || _a === void 0 ? void 0 : _a.menuClickFocus) === false) {
            event.preventDefault();
        }
        event.stopPropagation();
    }
    render() {
        this.badgeTree = this.props.badgeTree;
        const { itemStyle = {}, dropdownContentStyle = {} } = this.props;
        firstNonDivider = Infinity;
        let menus = this.props.menu
            .filter(item => !evaluate(item.shouldHide, false))
            .filter(this.removeUnnecessaryDivider);
        if (!menus.length) {
            return React.createElement("div", { onMouseDown: event => this.handleMouseDown(event) });
        }
        menus = menus.map(this.generateMenuTree);
        const levelInfo = this.getCurrentLevelInfo();
        const { needCheckPadding, hasIcon } = levelInfo;
        this.leaveMenuTree();
        return React.createElement("div", { onMouseDown: event => this.handleMouseDown(event), style: { maxHeight: '100%', height: '100%' } },
            React.createElement(Menu, { key: "main-menu-dropdown-menu", itemStyle: Object.assign({ minWidth: 104 }, itemStyle), onClick: this.handleMenuClick, selectable: needCheckPadding, type: hasIcon ? 'with-icon' : 'normal', className: `mainmenu-menu-${this.props.id}`, subMenuViewportMargin: 32, style: Object.assign({ overflow: 'auto', maxHeight: '100%' }, dropdownContentStyle) }, menus));
    }
}
MainMenuDropdown.contextType = EnvContext;
__decorate([
    Inject(),
    __metadata("design:type", BadgeService)
], MainMenuDropdown.prototype, "badgeService", void 0);
__decorate([
    Inject(),
    __metadata("design:type", MenuService)
], MainMenuDropdown.prototype, "menuService", void 0);
__decorate([
    Inject(),
    __metadata("design:type", WorkbenchSettingsService)
], MainMenuDropdown.prototype, "settings", void 0);

export { MainMenuDropdown };
//# sourceMappingURL=main-menu-dropdown.js.map
